module.exports = __webpack_public_path__ + "static/media/logo_large_banner.0e637803.jpg";